<template>
  <div>
    <div class="row mt-2 mb-2"></div>
    <p class="bb-hdg mt-2 mb-3">Traits</p>
    <template v-if="allowTraitSelection">
      <div class="row mt-2 mb-2 align-items-center">
        <div class="col-12 text-center">
          <div class="form-group">
            <div class="form-floating">
              <v-select
                :options="allTraits"
                :modelValue="selectedTraitId"
                label="name"
                :reduce="reduceTrait"
                class="form-control"
                placeholder="select..."
                @update:modelValue="handleTraitSelect"
                id="linked_trait"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <label
                class="bb-float-label optional"
                for="linked_trait"
              >
                Linked Trait
              </label>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="selectedTrait && selectedTrait.description"
        class="row mt-2 mb-2 align-items-center"
      >
        <div class="col-12 text-center">
          <div class="form-group">
            <div class="form-floating">
              <textarea
                readonly
                class="form-control bb-textarea-with-label bb-textarea-with-label-compact bb-card-description-control"
                :value="selectedTrait.description"
                id="linked_trait_description"
                disabled
              ></textarea>
              <label
                class="readonly bb-float-label optional"
                for="linked_trait_description"
              >
                Trait Description
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div
        v-for="trait in traits"
        :key="trait.id || trait.name"
        class="row mt-2 mb-2 align-items-center"
      >
        <div class="col-12 text-center">
          <div class="form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control text-left"
                :value="trait.name"
                :id="`trait_${trait.id || trait.name}_name`"
                disabled
              />
              <label
                class="readonly bb-float-label optional"
                :for="`trait_${trait.id || trait.name}_name`"
              >
                Trait
              </label>
            </div>

            <div
              v-if="trait.description"
              class="form-floating mt-2"
            >
              <textarea
                readonly
                class="form-control bb-textarea-with-label bb-textarea-with-label-compact bb-card-description-control"
                :value="trait.description"
                :id="`trait_${trait.id || trait.name}_description`"
                disabled
              ></textarea>
              <label
                class="readonly bb-float-label optional"
                :for="`trait_${trait.id || trait.name}_description`"
              >
                Trait Description
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ItemTraitsTab',
  props: {
    traits: {
      type: Array,
      required: true,
    },
    allTraits: {
      type: Array,
      default: () => [],
    },
    selectedTraitId: {
      type: String,
      default: null,
    },
    allowTraitSelection: {
      type: Boolean,
      default: false,
    },
    onTraitSelect: {
      type: Function,
      default: null,
    },
  },
  computed: {
    selectedTrait() {
      if (!this.selectedTraitId) {
        return this.traits[0] ?? null
      }

      return (
        this.allTraits.find((trait) => trait?.id === this.selectedTraitId) ??
        this.traits.find((trait) => trait?.id === this.selectedTraitId) ??
        null
      )
    },
    // selectedTrait() {
    //   if (!this.selectedTraitId) {
    //     return null
    //   }

    //   return (
    //     this.allTraits.find((t) => t?.id === this.selectedTraitId) ??
    //     this.traits.find((t) => t?.id === this.selectedTraitId) ??
    //     null
    //   )
    // },
  },
  methods: {
    reduceTrait(option) {
      return option?.id ?? null
    },
    handleTraitSelect(value) {
      if (typeof this.onTraitSelect === 'function') {
        this.onTraitSelect(value)
      }
    },
  },
}
</script>
